/**
 * Полоса графика оператора на день: зелёное — свободен, красное — занят.
 *
 * 09.09 (владелец): «в назначении доп работ у чипов операторов хочется, чтобы у верхнего
 * края чипа была полоса зелёно-красная, по которой можно было бы понять график человека
 * в этот день». Данные уже есть в чипе — BoardOperator.avail хранит свободные часы,
 * поэтому лишних запросов не нужно.
 */
import { AVAIL_HOURS } from "../../hooks/useAvailGrid";
import css from "./board.module.css";

const hh = (h: number) => `${String(h).padStart(2, "0")}:00`;

/** Часы подряд одним куском: «10:00–14:00, 19:00–23:00» — для подсказки на чипе. */
export function availSummary(avail: string[]): string {
  const free = new Set(avail);
  const runs: [number, number][] = [];
  for (const h of AVAIL_HOURS) {
    if (!free.has(hh(h))) continue;
    const last = runs[runs.length - 1];
    if (last && AVAIL_HOURS.indexOf(h) === AVAIL_HOURS.indexOf(last[1]) + 1) last[1] = h;
    else runs.push([h, h]);
  }
  if (!runs.length) return "весь день занят";
  if (runs.length === 1 && runs[0]![0] === AVAIL_HOURS[0] && runs[0]![1] === AVAIL_HOURS[AVAIL_HOURS.length - 1]) {
    return "свободен весь день";
  }
  return runs.map(([a, b]) => (a === b ? hh(a) : `${hh(a)}–${hh(b)}`)).join(", ");
}

/** Занятые часы одним куском: «10:00–14:00, 19:00–20:00». */
export function busySummary(avail: string[]): string {
  const free = new Set(avail);
  const runs: [number, number][] = [];
  for (const h of AVAIL_HOURS) {
    if (free.has(hh(h))) continue;
    const last = runs[runs.length - 1];
    if (last && AVAIL_HOURS.indexOf(h) === AVAIL_HOURS.indexOf(last[1]) + 1) last[1] = h;
    else runs.push([h, h]);
  }
  if (!runs.length) return "";
  return runs.map(([a, b]) => (a === b ? hh(a) : `${hh(a)}–${hh(b)}`)).join(", ");
}

export function AvailBar({ avail }: { avail: string[] }) {
  const free = new Set(avail);
  return (
    <span className={css.availBar} aria-hidden="true">
      {AVAIL_HOURS.map((h) => (
        <i key={h} className={free.has(hh(h)) ? css.availFree : css.availBusy} />
      ))}
    </span>
  );
}
